import axios from '@/request';
import qs from 'qs'

export default {
    async list(params: any) {
        return axios.get('robots/list', { params })
    },
    async add(params: any) {
        return axios.post('robots/add', qs.stringify(params))
    },
    async edit(params: any) {
        return axios.post('robots/edit', qs.stringify(params))
    },
    async detail(params: any) {
        return axios.get('robots/detail', { params })
    },
    async delete(params: any) {
        return axios.post('robots/delete', qs.stringify(params))
    },
    async reject(params: any) {
        return axios.post('robots/deposit-reject', qs.stringify(params))
    },
    async services(params: any) {
        return axios.get('robots/services', { params })
    }
}
